<template>
  <AppSafeZoneTop />
  <!-- restrict non-prod access to internal users (common password) -->
  <SiteAccessGuard>
    <AdminSessionBanner />
    <peg-alert v-if="apiUnavailable" class="q-ma-md" error dense icon centered role="alert" aria-live="assertive">
      Unable to reach the server. Some features may not work until the connection is restored.
      <q-btn flat dense label="Retry" class="q-ml-sm" color="white" :loading="retrying" @click="retryConnection" />
    </peg-alert>
    <router-view :key="sessionKey" />
  </SiteAccessGuard>
</template>

<script setup>
const pageMetaStore = usePageMetaStore()
const { pageMeta } = storeToRefs(pageMetaStore)
const sessionStore = useSessionStore()
const { sessionKey, apiUnavailable } = storeToRefs(sessionStore)

useNavigationGuards()

// apply meta to the page
useMeta(() => ({ ...pageMeta.value, titleTemplate: title => `${title} | Peg` }))

const retrying = ref(false)

async function retryConnection() {
  retrying.value = true
  await sessionStore.checkApiConnection()
  retrying.value = false
}

// check API connectivity on app startup (skip in Cypress to avoid flakiness)
onMounted(() => {
  if (typeof window !== 'undefined' && window.Cypress) {
    return
  }
  sessionStore.checkApiConnection()
})
</script>

<style scoped></style>
